import * as React from 'react';
import { Builder } from '@builder.io/react';
import image from '@/assets/images/cms/articleHeader.svg?inline';

/**
 * The block takes no inputs on purpose. Everything is read from the page's own fields,
 * so the editor only decides where the header is placed.
 */
export type ArticleHeaderComponentProps = Record<string, never>;

const register = (Component: React.FC): void => {
	Builder.registerComponent(Component, {
		name: 'ArticleHeader',
		image,
		inputs: [],
	});
};

export default register;
